import Index from '../../pages/sakura/lottery/index';
import Help from '../../pages/sakura/lottery/help';
import Pc from '../../pages/sakura/lottery/pc';

const base = 'lottery';

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/help*`,
        name: `${base}-help`,
        component: Help
    },
    {
        path: `/${base}/pc*`,
        name: `${base}-pc`,
        component: Pc
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/sakura/lottery.js